import React, { useEffect, useRef, useState } from "react";
import Select from 'react-select';
import axios from "axios";
import { serverUrl } from '../../components/Helpers/Config'
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";
import { useDispatch } from "react-redux";
import ActionButton from '../../components/Button/ActionButton';
import '../../styles/addpost.styles.scss'
import Swal from "sweetalert2";
import { staticFiles } from "../../components/Helpers/Static";
import CancelButton from '../../components/Button/CancelButton'
import RatingStar from '../../components/LikeComment/RatingStar';
import { tokenAuthorize } from "../../components/Helpers/Common";
import {
    ButtonCommonDelete,
    ButtonCommonTopGrey,
    ButtonCommonTopNew,
    Card,
    MenuItemCard,
    MenuItemDiv,
} from "../Theme";
const QuickPoll = ({ data, updatedData, isOpenQuickPoll }) => {
    const history = useHistory();
    const urlParams = useParams();
    const [isLoading, setLoading] = useState(false);
    const [errorPoll, setErrorPoll] = useState(false);

    const handleRating = (ratingCount, label, index) => {
        updatedData((prevData) => {
            const updatedPrevData = [...prevData];
            updatedPrevData[index] = {
                ...updatedPrevData[index],
                response_rating: ratingCount,
                rating_text: label,
            };
            return updatedPrevData;
        });
        setErrorPoll(false);
    };

    useEffect(() => {
        setErrorPoll(false);
    }, [updatedData]);

    const handlePollSubmit = () => {
        setErrorPoll(false);
        let mandatoryCheck = data.filter(item =>
            item.is_mandatory === true && (
                (item.type === 'Ratings' && item.response_rating == 0) ||
                (item.type === 'Textbox' && item.response_text?.trim() == "") ||
                (item.type === 'Dropdown' && item.response_text?.trim() == "")
            )
        );
        if (mandatoryCheck?.length == 0) {
            const pollquestionsArray = data.map(item => {
                if (item.type === 'Ratings') {
                    return {
                        question_id: item.id,
                        rating_text: item.rating_text,
                        response_rating: item.response_rating == 0 ? null : item.response_rating
                    };
                }
                else if (item.type === 'Textbox' || item.type === 'Dropdown') {
                    return {
                        question_id: item.id,
                        response_text: item.response_text
                    };
                }
            }).filter(item => item);
            let dataArray = {
                "poll_id": data[0].poll_id,
                "model_id": data[0].model_id,
                "reflection_id": urlParams.postId,
                "responses": pollquestionsArray
            }

            axios.post(serverUrl.ReflectionPollResponse, dataArray
            )
                .then((resp) => {
                    updatedData([]);
                    if (isOpenQuickPoll) {
                        history.push("/journal");
                        Swal.fire({
                            title: 'Success',
                            text: "Post has been updated",
                            icon: "success"
                        });
                    }
                    else {
                        Swal.fire({
                            title: 'Success',
                            text: "Poll has been submitted",
                            icon: "success"
                        });
                    }
                    if (resp.status === 200) {
                    }
                })
                .catch((err) => {
                    tokenAuthorize(err?.response?.status);
                })
        }
        else {
            setErrorPoll(true);
        }
    }

    const handleCancelButton = () => {
        if (isOpenQuickPoll) {
            history.push("/journal");
            Swal.fire({
                title: 'Success',
                text: "Post has been updated",
                icon: "success"
            });
        }
    }

    if (isLoading) return (
        <div className='w-full flex justify-center'>
            <img src={staticFiles.loading} alt='Loading...' className='w-10 h-10' />
        </div>
    )
    else return (
        <div className=''>
            <div className="">
                {data && data?.map((i, index) => (
                    i.type === "Ratings" ? <>
                        <div className="flex flex-col w-full gap-1">
                            <label className="pt-2 text-sm w-full poll-question">{i.text} {i.is_mandatory && <span className="text-red-600 text-lg">*</span>}</label>
                            <div>
                                <RatingStar variant="simple" totalStars={i.rating_star_count} initialRating={i.response_rating} onRating={handleRating} ratingLabels={i?.options} index={index} />
                            </div>
                        </div>
                    </> : i.type === "Dropdown" ? <>
                        <div className="w-full mt-2">
                            <div className="poll-question pb-1">{i.text} {i.is_mandatory && <span className="text-red-600 text-lg">*</span>}</div>
                            <Select
                                value={i.response_text ?
                                    {
                                        label: i.response_text,
                                        value: i.response_text
                                    } : ''}
                                options={i?.options?.map(item => ({
                                    label: item,
                                    value: item
                                }))}

                                onChange={(selectedOption) => {
                                    updatedData((prevData) => {
                                        const updatedPrevData = [...prevData];
                                        updatedPrevData[index] = {
                                            ...updatedPrevData[index],
                                            response_text: selectedOption.value,
                                        };
                                        return updatedPrevData;
                                    });
                                    setErrorPoll(false);
                                }}

                            />

                        </div>
                    </> : <>
                        <div className="w-full mt-2">
                            <div className="poll-question pb-1">{i.text} {i.is_mandatory && <span className="text-red-600 text-lg">*</span>}</div>
                            <textarea
                                value={i.response_text || ''}
                                placeholder="Enter your feedback"
                                rows="3"
                                className="text-sm w-full h-24 pt-1 px-3  border-2 rounded-lg outline-none text-black"
                                onChange={(e) => {
                                    const { value } = e.target;
                                    updatedData((prevData) => {
                                        const updatedPrevData = [...prevData];
                                        updatedPrevData[index] = {
                                            ...updatedPrevData[index],
                                            response_text: value,
                                        };
                                        return updatedPrevData;
                                    });
                                    setErrorPoll(false);
                                }}

                            />
                        </div>
                    </>
                ))}
            </div>
            {errorPoll && <div className="flex gap-2 mt-1">
                <span className="text-red-600 text-xs">Please respond to the mandatory poll question(s)</span>
            </div>
            }
            <div className="flex gap-2 h-10 justify-center mt-2">
                {isOpenQuickPoll &&
                    <ButtonCommonTopGrey className="flex items-center justify-center border p-2 rounded-lg cursor-pointer text-sm" onClick={() => handleCancelButton()}>
                        Cancel
                    </ButtonCommonTopGrey>}
                <ButtonCommonTopNew className="flex items-center justify-center border p-2 rounded-lg cursor-pointer text-sm" onClick={handlePollSubmit}>
                    Submit Poll
                </ButtonCommonTopNew>
                {/* <ActionButton title="Submit Poll" className={"px-2 py-2.5 w-20  text-sm"}
                    onClick={handlePollSubmit}
                /> */}
            </div>
        </div>
    )
};

export default QuickPoll;
